import { AlertModalProps } from "app/utils/modal/AlertModal";
import { IContractData, IExcelData, IFixedRecipe, IFixedStructure, IIngredientFrequency, IRules, IStructure, IWeekDays } from "../excelToJson/IExcel";
import { createContract } from "./send-contract.service";
export const validateContractDocuments = (dataContract: IContractData[]): boolean => {
    try {
        arrayValueToString(dataContract);
        const requiredFields: string[] = ["Regimen Código", "Servicio Código", "Costo_Objetivo", "Ciclos_Minuta", "Ciclo Plantilla (dias x semanas)", "Ciclos (Semanas", "Tipo_Frecuencia sodexo = 0, contractual = 1", "Tipo_Plantilla (Rotativa = 1, Fija = 2, No rotativa = 3)"];
        const missingFields: string[] = dataContract.reduce((acc: string[], contractDocument) => {
            const missing = requiredFields.filter(field =>
                !contractDocument.hasOwnProperty(field) || contractDocument[field as keyof IContractData] === null || contractDocument[field as keyof IContractData] === null
            );
            return acc.concat(missing);
        }, [])
        if (missingFields.length > 0) {
            console.error("Campos requeridos faltantes en al menos uno de los objetos en la hoja Datos_contrato:", missingFields.join(', '));
            return false;
        }
        return true;
    } catch (error) {
        console.error("Error en validateContractDocuments en la hoja Datos_contrato:", error);
        return false;
    }
};

export const validateWeekDays = (dataWeekDays: IWeekDays[]): boolean => {
    try {
        arrayValueToString(dataWeekDays);
        const requiredFields: string[] = ["Servicio Código", "Regimen Código", "Numero Dia", "Comensales", "Cod_Sitio"];
        const missingFields: string[] = dataWeekDays.reduce((acc: string[], weekDay) => {
            const missing = requiredFields.filter(field =>
                !weekDay.hasOwnProperty(field) || weekDay[field as keyof IWeekDays] === null || weekDay[field as keyof IWeekDays] === ''
            );
            return acc.concat(missing);
        }, [])
        if (missingFields.length > 0) {
            console.error("Campos requeridos faltantes en al menos uno de los objetos en la hoja Dias_semanas:", missingFields.join(', '));
            return false;
        }
        const isValidDayOfWeek = dataWeekDays.every(weekDay => {
            const dayNumber = parseInt(weekDay["Numero Dia"]);
            return !isNaN(dayNumber) && dayNumber >= 1 && dayNumber <= 7;
        });
        if (!isValidDayOfWeek) {
            console.error("Al menos una fila no cumple con la condición de contener números del 1 al 7 en 'Dia' en la hoja Dias_semanas.");
            return false;
        }
        const groupedByCodSitioRegimenCodigoServicioCodigo = dataWeekDays.reduce((acc, weekDay) => {
            const codSitio = weekDay["Cod_Sitio"].toString();
            const regimenCodigo = weekDay["Regimen Código"].toString();
            const servicioCodigo = weekDay["Servicio Código"].toString();
            const uniqueKey = `${codSitio}_${regimenCodigo}_${servicioCodigo}`;
            if (!acc.has(uniqueKey)) {
                acc.set(uniqueKey, []);
            }
            acc.get(uniqueKey)?.push(weekDay);
            return acc;
        }, new Map<string, IWeekDays[]>());
        const invalidCombinations: string[] = [];
        Array.from(groupedByCodSitioRegimenCodigoServicioCodigo).forEach(([key, rows]) => {
            const isValid = Array.from({ length: 7 }, (_, dayNumber) => {
                return rows.some(weekDay => parseInt(weekDay["Numero Dia"]) === dayNumber + 1);
            }).every(hasDay => hasDay);
            if (!isValid) {
                invalidCombinations.push(key);
            }
        });
        if (invalidCombinations.length > 0) {
            console.error("Las siguientes combinaciones de 'Cod_Sitio', 'Regimen Código' y 'Servicio Código' no tienen filas para todos los días del 1 al 7 en la hoja Dias_semanas:");
            invalidCombinations.forEach(combination => {
                console.error(combination);
            });
            return false;
        }
        return true;
    } catch (error) {
        console.error("Error en validateWeekDays:", error);
        return false;
    }
};

export const validateStructure = (dataStructure: IStructure[]): boolean => {
    try {
        const requiredFields: string[] = [
            "Estructura código",
            "Estructura nombre",
            "Tipo_Plato",
            "Orden",
            "Macro_Estructura código",
            "Servicio Código",
            "Regimen Código",
            "Cod_Sitio",
            "Categoria_Dietetica código",
            "Intolerancias",
            "Alergenos"
        ];
        const missingFields: string[] = dataStructure.reduce((acc: string[], structure) => {
            const missing = requiredFields.filter(field =>
                !structure.hasOwnProperty(field) || structure[field as keyof IStructure] === null || structure[field as keyof IStructure] === ''
            );
            return acc.concat(missing);
        }, [])
        if (missingFields.length > 0) {
            console.error("Campos requeridos en la hoja Estructura, faltantes en al menos uno de los objetos:", missingFields.join(', '));
            return false;
        }
        const dataValidate: Set<string> = new Set();
        let validatePK: boolean = true;
        dataStructure.forEach((value: IStructure, key) => {
            const dataPK = `${value['Estructura código']},${value['Servicio Código']},${value['Regimen Código']},${value['Cod_Sitio']}`;
            if (dataValidate.has(dataPK)) {
                console.error(`Datos duplicados en fila ${key + 1}: ${dataPK} en la hoja Estructura`);
                validatePK = false;
            } else {
                dataValidate.add(dataPK);
            }
        });
        if(validatePK) {
        }
        return validatePK;
    } catch (error) {
        console.error("Error en validateStructure:", error);
        return false;
    }
};

export const validateFixedStructure = (dataFixedStructure: IFixedStructure[]): boolean => {
    try {
        arrayValueToString(dataFixedStructure);
        const requiredFields: string[] = ["Cod_Sitio", "Nombre_Sitio", "Regimen Código", "Regimen Nombre", "Servicio Código", "Servicio Nombre", "Código Grupo estructura", "Grupo estructura", "Cod_Receta código"];
        const missingFields: string[] = dataFixedStructure.reduce((acc: string[], fixedStructure) => {
            const missing = requiredFields.filter(field =>
                !fixedStructure.hasOwnProperty(field) || fixedStructure[field as keyof IFixedStructure] === null || fixedStructure[field as keyof IFixedStructure] === ''
            );
            return acc.concat(missing);
        }, [])
        if (missingFields.length > 0) {
            console.error("Campos requeridos en la hoja Estructura_Fija faltantes en al menos uno de los objetos:", missingFields.join(', '));
            return false;
        }
        const dataValidate: Set<string> = new Set();
        let validatePK: boolean = true;
        dataFixedStructure.forEach((value: IFixedStructure, key) => {
            const dataPK = `${value["Cod_Receta código"]},${value['Servicio Código']},${value['Regimen Código']},${value['Cod_Sitio']}`;
            if (dataValidate.has(dataPK)) {
                console.error(`Datos duplicados en fila ${key + 1}: ${dataPK} en la hoja Estructura_Fija`);
                validatePK = false;
            } else {
                dataValidate.add(dataPK);
            }
        });
        if(validatePK) {
        }
        return validatePK;
    } catch (error) {
        console.error("Error en validateFixedStructure en la hoja Estructura_Fija:", error);
        return false;
    }
}

export const validateFixedRecipe = (dataFixedRecipe: IFixedRecipe[]): boolean => {
    arrayValueToString(dataFixedRecipe);
    const requiredFields: string[] = ["Servicio Código", "Ingrediente_Principal", "Categoria_Dietetica", "estructura", "receta", "dia num", "Semana"];
    const missingFields: string[] = dataFixedRecipe.reduce((acc: string[], frequencyIngPend) => {
        const missing = requiredFields.filter(field =>
            !frequencyIngPend.hasOwnProperty(field) || frequencyIngPend[field as keyof IFixedRecipe] === null || frequencyIngPend[field as keyof IFixedRecipe] === ''
        );
        return acc.concat(missing);
    }, []);
    if (missingFields.length > 0) {
        console.error("Campos requeridos faltantes en al menos uno de los objetos:", missingFields.join(', '));
        return false;
    }
    return true;
}

export const validateRules = (dataRules: IRules[]) => {
    try {
        arrayValueToString(dataRules);
        const requiredFields: string[] = ["Cod_Sitio", "Regimen Código", "Servicio Código"];
        const missingFields: string[] = dataRules.reduce((acc: string[], rule) => {
            const missing = requiredFields.filter(field =>
                !rule.hasOwnProperty(field) || rule[field as keyof IRules] === null || rule[field as keyof IRules] === ''
            );
            return acc.concat(missing);
        }, [])
    } catch (error) {
        console.error("Error en validateFixedStructure:", error);
        return false;
    }
}

export const validateFrequencyIngredients = (dataFrequencyIngredients: IIngredientFrequency[]): boolean => {
    try {
        arrayValueToString(dataFrequencyIngredients);
        const requiredFields: string[] = ["Cod_Sitio", "Semanas", "Nombre_Sitio", "Regimen Código", "Regimen Nombre", "Servicio Código", "Servicio Nombre", "Frecuencia", "Estructura código", "Estructura nombre", "id_cat_dietetica", "Categoria_Dietetica", "Ingrediente_Principal código"];
        const missingFields: string[] = dataFrequencyIngredients.reduce((acc: string[], frequencyIng) => {
            const missing = requiredFields.filter(field =>
                !frequencyIng.hasOwnProperty(field) || frequencyIng[field as keyof IIngredientFrequency] === null || frequencyIng[field as keyof IIngredientFrequency] === ''
            );
            return acc.concat(missing);
        }, []);
        if (missingFields.length > 0) {
            console.error("Campos requeridos faltantes en al menos uno de los objetos:", missingFields.join(', '));
        }
        const errorFields = new Set<string>();
        checkRows(dataFrequencyIngredients, errorFields);

        errorFields?.forEach(errorField => {
            console.error(`Los campos ${errorField} tienen id_cat_dietetica diferente en filas.`);
        });

        return missingFields.length === 0 && errorFields.size === 0;
    } catch (error) {
        console.error("Error en validateFixedStructure:", error);
        return false;
    }
}

const checkRows = (rows: IIngredientFrequency[], errorFields: Set<string>): void => {
    if (rows.length <= 1) return;

    const [firstRow, ...restRows] = rows;
    restRows.forEach(row => {
        if (
            row["Estructura código"] === firstRow["Estructura código"] &&
            row["Ingrediente_Principal código"] === firstRow["Ingrediente_Principal código"] &&
            row["id_cat_dietetica"] !== firstRow["id_cat_dietetica"]
        ) {
            errorFields.add(`"Estructura código": ${row["Estructura código"]}, "Ingrediente_Principal código": ${row["Ingrediente_Principal código"]}`);
        }
    });

    checkRows(restRows, errorFields);
};

export const arrayValueToString = (array: any[]): void => {
    array.forEach(obj => {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = obj[key].toString();
            }
        }
    });
}

export const validateExcel = async (dataExcel: IExcelData | any, setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>): Promise<void> => {
    const validations = [
        { name: 'Datos_contrato', validator: validateContractDocuments },
        { name: 'Dias_semanas', validator: validateWeekDays },
        { name: 'Estructura', validator: validateStructure },
        { name: 'Estructura_Fija', validator: validateFixedStructure },
        { name: 'Receta_Fija', validator: validateFixedRecipe },
        { name: 'Frecuencia_Ingredientes', validator: validateFrequencyIngredients }
    ];
    const failedValidations = validations.filter(validation => {
        if ((dataExcel as any)[validation.name]) {
            const data = !validation.validator(dataExcel[validation.name])
            return data;
        }
    });

    if (failedValidations.length === 0) {
        console.time();
        await createContract(dataExcel, setAlertModal);
    } else {
        const failedNames = failedValidations.map(v => v.name).join(', ');
        console.error(`Las siguientes validaciones fallaron en la hoja del excel: ${failedNames}`);
    }
}